import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TransferenceDocumentType, getDocumentTypeFromId } from '@autofact-lib/operation-lib-model-notary-platform';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { formats } from '../../config';
import AuthService from '../../services/AuthService';
import { NOTARY_CONFIG_AUTOFACT_REPRESENTATION_VALUE } from '../../helpers/NotaryAutofactRepresentationHelper';
import EditPeopleInContract from '../edit-people-in-contract/EditPeopleInContract';

const RNDPATypes = [
  TransferenceDocumentType.RNDPA_BACKUP.id,
  TransferenceDocumentType.RNDPA_CERTIFICATE.id,
];

const REPRESENTATION_CONTRACT_DOCUMENTS_TYPES = [
  TransferenceDocumentType.PACKAGE_TYPE_MANDATE_BUYER_FEA.id,
  TransferenceDocumentType.PACKAGE_TYPE_MANDATE_SELLER_FEA.id,
  TransferenceDocumentType.REPRESENTATION_CONTRACT_TYPE.id,
  TransferenceDocumentType.CONTRACT_BUYER_FIRST.id,
];

const DOCUMENTS_TO_HIDE_IN_REPRESENTATION_SIGNATURE = [
  TransferenceDocumentType.CONTRACT.id,
  TransferenceDocumentType.MANDATE_BUYER.id,
  TransferenceDocumentType.MANDATE_SELLER.id,
];

const DOCUMENTS_WITH_EDIT_BUTTON = [
  TransferenceDocumentType.CONTRACT.id,
  TransferenceDocumentType.REPRESENTATION_CONTRACT_TYPE.id,
];

const ACTIVE_DOCUMENT_VALUE = 1;
const DELETED_DOCUMENT_VALUE = -2;

class DocumentSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentList: [],
      showModal: false,
    };
  }

  componentDidMount() {
    this.loadDocumentList();
  }

  async loadDocumentList() {
    const documentList = await this.filterData();
    this.setState({ documentList });
  }

  async filterData() {
    const authData = await AuthService.getAuthData();
    const { notary } = authData;
    const representativeSignature = notary.autofactRepresentation === NOTARY_CONFIG_AUTOFACT_REPRESENTATION_VALUE.ENABLED
            && this.props.isNotarialFlowRepresentation
            && this.props.subsidiaryRepresentationFlow;
    const documentList = this.props.documentList.filter((document) => {
      let result = false;
      if (document.estado !== DELETED_DOCUMENT_VALUE) {
        if (representativeSignature && REPRESENTATION_CONTRACT_DOCUMENTS_TYPES.includes(document.tipo)) {
          result = true;
        } else if (representativeSignature && (DOCUMENTS_TO_HIDE_IN_REPRESENTATION_SIGNATURE.includes(document.tipo) || !getDocumentTypeFromId(document.tipo))) {
          result = false;
        } else if (document.estado === ACTIVE_DOCUMENT_VALUE || RNDPATypes.includes(document.tipo)) {
          result = true;
        }
      }
      return result;
    });
    if (representativeSignature) {
      const pack = documentList.find((document) => document.tipo === TransferenceDocumentType.PACKAGE.id);
      if (pack) {
        this.props.onDocumentSelect(pack);
      } else {
        const representativeContract = documentList.find((document) => document.tipo === TransferenceDocumentType.REPRESENTATION_CONTRACT_TYPE.id);
        if (representativeContract) {
          this.props.onDocumentSelect(representativeContract);
        }
      }
    }
    return documentList;
  }

  openModal = () => {
    this.setState({ showModal: true });
  };

  cancelModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const documentsRender = [];
    const rndpaDocsList = [];
    let componentElement = null;

    this.state.documentList.forEach((document) => {
      const DocumentType = getDocumentTypeFromId(document.tipo);
      let documentTitle = DocumentType ? DocumentType.label : 'OTRO';
      if (DocumentType && DocumentType.id === TransferenceDocumentType.OTHER.id) {
        documentTitle += ` (${document.nombre})`;
      }
      componentElement = (
        <li className="nav-item document-item-wrapper" key={`document-item-${document.iddocumento}`}>
          <a
            href={document.ruta_fisica}
            onClick={(event) => {
              event.preventDefault();
              if (this.props.onDocumentSelect) {
                this.props.onDocumentSelect(document);
              }
            }}
          >
            <div className="document-icon"><FontAwesomeIcon icon="file-pdf" /></div>
            <div
              className="document-title"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>{documentTitle}</span>
              {DOCUMENTS_WITH_EDIT_BUTTON.includes(document.tipo) ? (
                <Button
                  style={{
                    color: '#FF4E04',
                    backgroundColor: 'transparent',
                    border: 'none',
                    boxShadow: 'none',
                    fontSize: '16px',
                    fontFamily: 'Source Sans Pro',
                    padding: '0rem 2.75rem 0rem 0rem',
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.openModal();
                  }}
                >
                  <BorderColorIcon style={{
                    height: '16px',
                    width: '16px',
                  }}
                  />
                  {' '}
                  Editar
                </Button>
              ) : null}
            </div>
            <div className="document-date">{moment(document.timestamp_modificacion).format(formats.date)}</div>
          </a>
        </li>
      );

      if (document.estado === ACTIVE_DOCUMENT_VALUE && !RNDPATypes.includes(document.tipo)) {
        documentsRender.push(componentElement);
        return;
      }

      if (REPRESENTATION_CONTRACT_DOCUMENTS_TYPES.includes(document.tipo)) {
        documentsRender.push(componentElement);
        return;
      }

      if ((typeof rndpaDocsList[document.persona_idpersona] === 'undefined') || (document.tipo === TransferenceDocumentType.RNDPA_CERTIFICATE.id && rndpaDocsList[document.persona_idpersona].tipo !== TransferenceDocumentType.RNDPA_CERTIFICATE.id) || (document.tipo === rndpaDocsList[document.persona_idpersona].tipo && rndpaDocsList[document.persona_idpersona].timestamp < moment(document.timestamp))) {
        rndpaDocsList[document.persona_idpersona] = { tipo: document.tipo, timestamp: moment(document.timestamp) };
        documentsRender[document.persona_idpersona] = componentElement;
      }
    });
    return (
      <div>
        {this.state.showModal && (
        <EditPeopleInContract
          open={this.state.showModal}
          handleClose={this.cancelModal}
          persons={this.props.persons}
          plate={this.props.plate}
          transferenceCode={this.props.transferenceCode}
          onUpdatePersons={this.props.onUpdatePersons}
        />
        )}
        <ul className="transference-document-list">
          {documentsRender}
        </ul>
      </div>
    );
  }
}

DocumentSelector.propTypes = {
  documentList: PropTypes.array,
  isNotarialFlowRepresentation: PropTypes.bool,
  onDocumentSelect: PropTypes.func,
  onUpdatePersons: PropTypes.func,
  persons: PropTypes.array,
  plate: PropTypes.string,
  subsidiaryRepresentationFlow: PropTypes.bool,
  transferenceCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DocumentSelector;
